module.exports = __webpack_public_path__ + "assets/img/SV_Private_Logo.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SV_Private_Logo.jpg
// module id = 1916
// module chunks = 0